export default __webpack_public_path__ + "static/media/falinks-cover.54703e19.jpeg";